import { network } from 'services/network';

import { QueryParams } from 'api/mutations/runQsraAnalysis.mutate';

export const runQsraAnalysis = (params: QueryParams) => {
    const url = `api/bo/runQsraAnalysis`;
    return network.post(url, params).then((response) => response.data);
};
